import { createMuiTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import teal from '@material-ui/core/colors/teal';
import red from '@material-ui/core/colors/red';
import { fade } from '@material-ui/core/styles';

export const papayaLogoColors = {
  darkGreen: '#158D71',
  green: '#10a488',
  lightGreen: '#56BA8F',
  lime: '#a4d08e',
  yellow: '#FAF2A1',
  lightRed: '#f16f58',
  red: '#ed583c',
  darkRed: '#d1472c',
};

export const papayaPalette = {
  ...papayaLogoColors,
  darkGrey: '#454545',
  grey: '#474747',
  eventGrey: '#747474',
  lightGrey: '#6b6b6c',
  tagsGray: '#eaeaec',
  borderGray: '#ececee',
  dividerGray: '#BFBFBF',
  iconGray: '#7f7f7f',
  redesignGray: '#EAEAEC',
  gridGray: '#B7B7B7',
  borderGray2: '#E9E9EB',
  noItemsGray: '#F9F9F9',
  placeholderGrey: '#d7d7da',
  sectionHeader: '#f5f5f6',
  white: '#fff',
  black: '#000000',
};

export const palette = {
  primary1Color: papayaPalette.white,
  primary2Color: teal[600],
  primary3Color: teal[300],
  accent1Color: papayaPalette.red,
  accent2Color: orange[800],
  accent3Color: teal[200],
  textColor: papayaPalette.darkGrey,
  alternateTextColor: grey[300],
  canvasColor: papayaPalette.white,
  background1Color: papayaPalette.grey,
  background2Color: grey[900],
  background3Color: fade(grey[900], 0.4),
  disabledColor: fade(papayaPalette.darkGrey, 0.3),
  borderColor: papayaPalette.darkGrey,
  eventGrey: papayaPalette.eventGrey,
  successColor: green[500],
  failureColor: red[700],
  hoverColor: grey[200],
  noItemsGray: papayaPalette.noItemsGray,

  darkRed: papayaPalette.darkRed,
  red: papayaPalette.red,
  lightRed: papayaPalette.lightRed,
  darkGreen: papayaPalette.darkGreen,
  green: papayaPalette.green,
  lightGreen: papayaPalette.lightGreen,
  lime: papayaPalette.lime,
  yellow: papayaPalette.yellow,
  darkGrey: papayaPalette.darkGrey,
  grey: papayaPalette.grey,
  lightGrey: papayaPalette.lightGrey,
  tagsGray: papayaPalette.tagsGray,
  borderGray: papayaPalette.borderGray,
  dividerGray: papayaPalette.dividerGray,
  iconGray: papayaPalette.iconGray,
  gridGray: papayaPalette.gridGray,
  borderGray2: papayaPalette.borderGray2,
  placeholderGrey: papayaPalette.placeholderGrey,
  redesignGray: papayaPalette.redesignGray,
  sectionHeader: papayaPalette.sectionHeader,
  white: papayaPalette.white,
  black: papayaPalette.black,
};

export const toggleStyle = {
  green: {
    backgroundColor: palette.lightGreen,
  },
  grey: {
    backgroundColor: palette.lightGrey,
  },
  greyBorder: {
    backgroundColor: palette.white,
    border: '1px solid ' + palette.lightGrey,
  },
};

export default (() => {
  const badge = {
    primaryColor: palette.lightGreen,
    primaryTextColor: palette.textColor,
  };
  const checkbox = {
    checkedColor: palette.accent1Color,
  };
  const floatingActionButton = {
    iconColor: palette.textColor,
    color: palette.lime,
    secondaryIconColor: palette.textColor,
  };
  const textField = {
    textColor: palette.textColor,
    hintColor: palette.textColor,
    floatingLabelColor: palette.textColor,
  };
  const raisedButton = {
    primaryTextColor: palette.textColor,
    secondaryTextColor: palette.textColor,
  };
  const flatButton = {
    primaryTextColor: palette.textColor,
    secondaryTextColor: palette.textColor,
  };

  const datePicker = {
    color: palette.textColor,
  };

  const radioButton = {
    checkedColor: palette.textColor,
  };

  const overwrites = {
    fontFamily: 'ProximaNova, sans-serif',
    badge,
    checkbox,
    floatingActionButton,
    palette,
    raisedButton,
    textField,
    flatButton,
    datePicker,
    radioButton,
  };
  return createMuiTheme({ overwrites });
})();



// WEBPACK FOOTER //
// ./src/papaya-theme.js